module.exports = __webpack_public_path__ + "img/badge-ar.1d87ec9e.svg";